
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators } from './../../../scripts/formcontrols'
import { AddressDto } from "./../../../dto/address"

export class AddressEditorController extends FormPageValidator {

    private _original: AddressDto;
           
    public addressType:    FormElementController<string>;
    public addressLine:    FormElementController<string>;
    public postCode:       FormElementController<string>;
    public town:           FormElementController<string>;
    public county:         FormElementController<string>;
    public country:        FormElementController<string>;

    public isEditing: boolean;

    constructor(addressDto: AddressDto) {
        super()

        this.isEditing = false;
        this._original = addressDto;

        var addressTypeValidator    = new FormElementValidator(true);
        var addressLineValidator    = new FormElementValidator(true);
        var postCodeValidator       = new FormElementValidator(true);
        var townValidator           = new FormElementValidator(true);
        var countyValidator         = new FormElementValidator(false);
        var countryValidator        = new FormElementValidator(false);

        this.addressType    = new FormElementController<string>("AddressType", this._original.addressType    , addressTypeValidator);
        this.addressLine    = new FormElementController<string>("AddressLine", this._original.addressLine    , addressLineValidator);
        this.postCode       = new FormElementController<string>("PostCode   ", this._original.postCode       , postCodeValidator);
        this.town           = new FormElementController<string>("Town       ", this._original.town           , townValidator);
        this.county         = new FormElementController<string>("County     ", this._original.county         , countyValidator);
        this.country        = new FormElementController<string>("Country    ", this._original.country        , countryValidator);

        this.addValidators(
            addressTypeValidator 
            ,addressLineValidator 
            ,postCodeValidator    
            ,townValidator        
            ,countyValidator      
            ,countryValidator);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/addressEditor/addressEditorController.ts